import React, { useEffect, useRef, useState } from "react";
import { t } from "../i18n";

// Affiche les demandes de confirmDialog / alertDialog (voir dialog.js), une à
// la fois. Échap annule, Entrée valide.
export default function DialogHost() {
  const [queue, setQueue] = useState([]);
  const okRef = useRef(null);
  const current = queue[0];

  useEffect(() => {
    const onDialog = (e) => setQueue(q => q.concat(e.detail));
    window.addEventListener("pq:dialog", onDialog);
    return () => window.removeEventListener("pq:dialog", onDialog);
  }, []);

  useEffect(() => { if (current) okRef.current?.focus(); }, [current]);

  if (!current) return null;
  const close = (value) => {
    current.resolve(current.kind === "confirm" ? value
      : current.kind === "choice" ? (value === false ? null : value) : undefined);
    setQueue(q => q.slice(1));
  };

  return (
    <div className="pq-dialog-overlay" onClick={() => close(false)}
      onKeyDown={e => { if (e.key === "Escape") close(false); }}>
      <div className="pq-dialog" role="alertdialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <p className="pq-dialog-message">{current.message}</p>
        {current.kind === "choice" ? (
          <div className="pq-dialog-actions pq-dialog-choices">
            {current.choices.map((c, i) => (
              <button key={c.value} type="button" ref={i === 0 ? okRef : undefined}
                className={`btn${c.primary ? " btn-primary" : ""}${c.danger ? " pq-dialog-danger" : ""}`}
                onClick={() => close(c.value)}>{c.label}</button>
            ))}
            <button type="button" className="btn" onClick={() => close(false)}>{t("common.cancel")}</button>
          </div>
        ) : (
        <div className="pq-dialog-actions">
          {current.kind === "confirm" && (
            <button type="button" className="btn" onClick={() => close(false)}>{t("common.cancel")}</button>
          )}
          <button type="button" ref={okRef}
            className={`btn ${current.danger ? "pq-dialog-danger" : "btn-primary"}`}
            onClick={() => close(true)}>
            {current.okLabel || t("common.ok")}
          </button>
        </div>
        )}
      </div>
    </div>
  );
}
